"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
exports.CONVERSION_STEP_META = {
    convertHtmlEntities: {
        activeTense: 'Convert HTML entities',
        displayName: 'Convert HTML entities',
        fields: ['name'],
        futureTense: 'convert HTML entities',
        icon: pro_light_svg_icons_1.faLanguage,
        pastTense: 'convert HTML entities',
        productStatus: 'isTodo',
    },
    findAndReplace: {
        activeTense: 'Find and replace',
        description: 'Replace matching text with new text. Note that this replaces tags and text within HTML code itself.',
        displayName: 'Find and replace',
        fields: ['name', 'textToFind', 'textToReplace'],
        futureTense: 'find and replace',
        icon: pro_light_svg_icons_1.faSearch,
        pastTense: 'found and replaced',
        productStatus: 'isExperimental',
    },
    hostImage: {
        activeTense: 'Uploading images matching',
        displayName: 'Host images',
        fields: ['name', 'selector'],
        futureTense: 'upload',
        icon: pro_light_svg_icons_1.faCloudUpload,
        pastTense: 'images uploaded',
        productStatus: 'isTodo',
    },
    insertAd: {
        activeTense: 'Inserting ad into',
        displayName: 'Insert ad',
        fields: ['name', 'ad', 'selector', 'adjacentInsertionPosition'],
        // TODO: adjust "into" depending on adjacentInsertionPosition
        futureTense: 'insert ad',
        icon: pro_light_svg_icons_1.faAd,
        pastTense: 'ad inserted',
        productStatus: 'isTodo',
    },
    remove: {
        activeTense: 'Removing',
        displayName: 'Remove',
        fields: ['name', 'selector', 'removeTarget'],
        futureTense: 'remove',
        icon: pro_light_svg_icons_1.faEraser,
        pastTense: 'removed',
        productStatus: 'isExperimental',
    },
    renameAttribute: {
        activeTense: 'Renaming attribute',
        displayName: 'Rename element attributes',
        fields: ['name', 'selector', 'fromAttribute', 'toAttribute'],
        futureTense: 'rename',
        icon: pro_light_svg_icons_1.faExchange,
        pastTense: 'renamed',
        productStatus: 'isTodo',
    },
    screenshot: {
        activeTense: 'Screenshotting',
        displayName: 'Screenshot elements',
        fields: [
            'name',
            'selector',
            'cssForATag',
            'cssForImgTag',
            'imgWidth',
            'linkToContentItem',
            'linkToFirstLink',
            'linkSelector',
            'headHtml',
            'overlayHtml',
            'includedHtml',
        ],
        futureTense: 'screenshot',
        icon: pro_light_svg_icons_1.faCamera,
        pastTense: 'screenshotted',
        productStatus: 'isTodo',
    },
    unwrap: {
        activeTense: 'Removing (unwrapping)',
        displayName: 'Remove (unwrap) elements',
        fields: ['name', 'selector'],
        futureTense: 'remove (unwrap)',
        icon: pro_light_svg_icons_1.faBoxOpen,
        pastTense: 'removed (unwrapped)',
        productStatus: 'isExperimental',
    },
    updateAttributeContents: {
        activeTense: 'Update attribute contents',
        displayName: 'Update attribute contents',
        fields: [
            'name',
            'selector',
            'attributeName',
            'doNothingIfAttributeExists',
            'attributeValue',
        ],
        futureTense: 'update attribute contents',
        icon: pro_light_svg_icons_1.faMarker,
        pastTense: 'attributes updated',
        productStatus: 'isExperimental',
    },
};
// AdjacentInsertionPosition
exports.CONVERSION_STEP_FIELD_META = {
    ad: {
        type: 'ad',
    },
    adjacentInsertionPosition: {
        options: [
            {
                label: 'Insert before matching elements',
                value: 'beforebegin',
            },
            {
                label: 'Insert into the matching elements, at the top',
                value: 'afterbegin',
            },
            {
                label: 'Insert into the matching elements, at the bottom',
                value: 'beforeend',
            },
            {
                label: 'Insert after matching elements',
                value: 'afterend',
            },
        ],
        type: 'select',
    },
    archived: {
        type: 'checkbox',
    },
    attributeName: {
        helpText: (react_1.default.createElement(react_1.default.Fragment, null,
            "Examples: ",
            react_1.default.createElement("code", null, "style"),
            ", ",
            react_1.default.createElement("code", null, "class"),
            ", or",
            ' ',
            react_1.default.createElement("code", null, "data-converted"),
            ", ",
            react_1.default.createElement("code", null, "__innerHTML"),
            ",",
            ' ',
            react_1.default.createElement("code", null, "__outerHTML"),
            ". Use ",
            react_1.default.createElement("code", null, "__innerHTML"),
            " or",
            ' ',
            react_1.default.createElement("code", null, "__outerHTML"),
            " to target the innerHTML or outerHTML of the found element, respectively. Note that ",
            react_1.default.createElement("code", null, "__outerHTML"),
            " will only work with nested elements.")),
        type: 'text',
    },
    attributeRemovalStrategy: {
        options: [
            {
                label: 'Whitelist',
                value: 'whitelist',
            },
            {
                label: 'Blacklist',
                value: 'blacklist',
            },
        ],
        type: 'select',
    },
    attributes: {
        type: 'text',
    },
    attributeValue: {
        type: 'text',
    },
    contentConversion: {
        type: 'text',
    },
    contentConversionId: {
        type: 'number',
    },
    createdAt: {
        type: 'text',
    },
    creatingUser: {
        type: 'text',
    },
    cssForATag: {
        label: 'CSS for wrapping `<a>` tag',
        type: 'text',
    },
    cssForImgTag: {
        label: 'CSS for `<img>` tag',
        type: 'text',
    },
    deleted: {
        type: 'checkbox',
    },
    doNothingIfAttributeExists: {
        type: 'checkbox',
    },
    fromAttribute: {
        type: 'text',
    },
    headHtml: {
        type: 'code',
    },
    id: {
        type: 'text',
    },
    imgWidth: {
        type: 'number',
    },
    includedHtml: {
        type: 'code',
    },
    linkSelector: {
        type: 'selector',
    },
    linkToContentItem: {
        type: 'checkbox',
    },
    linkToFirstLink: {
        type: 'checkbox',
    },
    localId: {
        type: 'text',
    },
    name: {
        type: 'text',
    },
    order: {
        type: 'text',
    },
    overlayHtml: {
        type: 'code',
    },
    paused: {
        type: 'text',
    },
    removeTarget: {
        type: 'text',
    },
    resourceAdminUrl: {
        type: 'text',
    },
    resourceEndpoint: {
        type: 'text',
    },
    resourceUrl: {
        type: 'text',
    },
    selector: {
        helpText: (react_1.default.createElement(react_1.default.Fragment, null,
            "Examples: ",
            react_1.default.createElement("code", null, ".my-class"),
            ", ",
            react_1.default.createElement("code", null, "[data-my-attr]"),
            ",",
            ' ',
            react_1.default.createElement("code", null, "[data-my-attr=\"my-val\"]"),
            ", ",
            react_1.default.createElement("code", null, "*"),
            ",",
            ' ',
            react_1.default.createElement("code", null, "blockquote"),
            ", ",
            react_1.default.createElement("code", null, "a img"),
            ", ",
            react_1.default.createElement("code", null, "div > p"),
            ",",
            ' ',
            react_1.default.createElement("code", null, "p:first-child"),
            ", ",
            react_1.default.createElement("code", null, "p:nth-child(3)"),
            ",",
            ' ',
            react_1.default.createElement("code", null, "p:nth-child(2n)"),
            " etc.",
            react_1.default.createElement("br", null),
            "Tip: Use ",
            react_1.default.createElement("code", null, ":scope"),
            " to target the top-level element. For example, use ",
            react_1.default.createElement("code", null, ":scope > div"),
            " to target ",
            react_1.default.createElement("code", null, "div"),
            ' ',
            "tags that are not nested within other tags.")),
        type: 'selector',
    },
    textToFind: {
        type: 'text',
    },
    textToReplace: {
        type: 'text',
    },
    toAttribute: {
        type: 'text',
    },
    // toEndpoint: {
    //   type: 'text',
    // },
    // toString: {
    //   type: 'text',
    // },
    // toUrl: {
    //   type: 'text',
    // },
    type: {
        type: 'text',
    },
    updatedAt: {
        type: 'text',
    },
};
//# sourceMappingURL=conversions.js.map